import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type UserWidgetConfigViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  userValue: { displayId: string; id: string } | null;
  widgetValue: { displayId: string; id: string } | null;
  enabledValue?: { displayId: string; id: string } | null;
  enabled: boolean;
  positionValue?: { displayId: string; id: string } | null;
  position: string;
  configOverrideValue?: { displayId: string; id: string } | null;
  configOverride: string;
  displayOrderValue?: { displayId: string; id: string } | null;
  displayOrder: number | undefined;
};

export const UserWidgetConfigViewForm: React.FC<UserWidgetConfigViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      userValue,
      widgetValue,
      enabled = false,
      position = "{}",
      configOverride = "{}",
      displayOrder = 0,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupUserWidgetConfigLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowReference
                  label={langStore.UserWidgetConfigUserLabel}
                  selectedValue={langStore.displayIdByLang(
                    userValue?.displayId
                  )}
                />
                <ShowReference
                  label={langStore.UserWidgetConfigWidgetLabel}
                  selectedValue={langStore.displayIdByLang(
                    widgetValue?.displayId
                  )}
                />
                <ShowBoolean
                  value={enabled}
                  label={langStore.UserWidgetConfigEnabledLabel}
                />
                <InputCodeEditor
                  value={position}
                  onChange={() => {}}
                  label={langStore.UserWidgetConfigPositionLabel}
                  language="json"
                  readOnly={true}
                />
                <InputCodeEditor
                  value={configOverride}
                  onChange={() => {}}
                  label={langStore.UserWidgetConfigConfigOverrideLabel}
                  language="json"
                  readOnly={true}
                />
                <ShowNumber
                  value={displayOrder}
                  label={langStore.UserWidgetConfigDisplayOrderLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
